import { BOOK_POSTERS } from '../../../utils/helpers/intro/data';
import styles from './Slide2.module.css';
import SlideShell from './SlideShell';

export default function Slide2({ handleNext, handlePrev, current, total, t }) {
  return (
    <SlideShell handleNext={handleNext} handlePrev={handlePrev} current={current} total={total} t={t}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <p className={styles.title}>{t("intro_stories_waiting_to_be_discovered_title")}</p>
          <p className={styles.text}>{t("intro_books_library_description")}</p>
        </div>
        <div className={styles.books}>
          {BOOK_POSTERS.map((img, index) => (
            <div key={index} className={styles.bookCard}>
              <img src={img} alt="" className={styles.bookImage} />
            </div>
          ))}
        </div>
      </div>
    </SlideShell>
  );
}